import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ProjectTotalEarningsDto } from '../../../commonTypes/acs';

const useHttpGetProjectTotalEarnings = (projectId: string, enabled: boolean = true) => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<ProjectTotalEarningsDto | null>(null);
    const { t } = useTranslation('newNotifications');

    const getEarnings = (id: string) => {
        if (!id || id.trim() === '') {
            setIsReady(true);
            return;
        }

        const { exec, abort } = projectApi.getProjectTotalEarnings({
            params: { projectId: id },
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => {
                console.error('Error fetching project total earnings:', error);
                toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
            },
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (!enabled) {
            setIsReady(true);
            return;
        }

        if (projectId && projectId.trim() !== '') {
            getEarnings(projectId);
        } else {
            setIsReady(true);
        }
    }, [projectId, enabled]);

    return { isReady, data, getEarnings };
};

export default useHttpGetProjectTotalEarnings;
